import { render, staticRenderFns } from "./shipMsg2side.vue?vue&type=template&id=f5fde3e8&scoped=true"
import script from "./shipMsg2side.vue?vue&type=script&lang=js"
export * from "./shipMsg2side.vue?vue&type=script&lang=js"
import style0 from "./shipMsg2side.vue?vue&type=style&index=0&id=f5fde3e8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fde3e8",
  null
  
)

export default component.exports